import { IconCloseRegular } from '@croquiscom-pvt/zds';
import styled from '@emotion/styled';

interface ItemCardRemoveProps {
  handleRemove: () => void;
}

export const ItemCardRemove = ({ handleRemove }: ItemCardRemoveProps) => {
  return (
    <RemoveButton>
      <IconCloseRegular size={20} color='textSecondary' />
      <TouchArea onClick={handleRemove} />
    </RemoveButton>
  );
};

const TouchArea = styled.div`
  position: absolute;
  top: -16px;
  right: -16px;
  width: 48px;
  height: 48px;
  cursor: pointer;
`;

const RemoveButton = styled.button`
  position: relative;
  height: 17px;
`;
